import styled from 'styled-components'
import { breakpoint } from '../../layout/mixins'
import Text from '../../components/blocks/Text'

export const StyledText = styled(Text)`
  ${breakpoint.down('tablet')`
    padding-top: ${({ theme }) => `calc(${theme.gutter} * 5)`};
  `}
`